import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = {
    key: 0,
    class: "px-3 lg:px-4 pt-3 pb-2"
};
const _hoisted_3 = { class: "flex justify-between items-center" };
const _hoisted_4 = { class: "font-semibold" };
const _hoisted_5 = ["aria-label", "title"];
const _hoisted_6 = { class: "my-1 text-muted collapsible-content" };
const _hoisted_7 = { class: "divide-y divide-(--default-border-color) border-t border-(--default-border-color) list-unstyled" };
const _hoisted_8 = { class: "flex" };
const _hoisted_9 = { class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_10 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_11 = ["textContent"];
const _hoisted_12 = { class: "flex" };
const _hoisted_13 = { class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_14 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_15 = ["textContent"];
const _hoisted_16 = { class: "flex" };
const _hoisted_17 = { class: "px-3 lg:px-4 py-2 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_18 = { class: "px-3 lg:px-4 py-2 grow" };
const _hoisted_19 = ["textContent"];
const _hoisted_20 = {
    key: 0,
    class: "flex"
};
const _hoisted_21 = { class: "px-3 lg:px-4 pt-2 pb-3 basis-7/12 sm:basis-6/12 md:basis-8/12 lg:basis-9/12 xl:basis-8/12 2xl:basis-7/12" };
const _hoisted_22 = { class: "px-3 lg:px-4 pt-2 pb-3 grow" };
const _hoisted_23 = ["textContent"];
import { computed, ref } from 'vue';
import { ___, toFixedNumberStrWithFallback } from '@ts/common/language';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Threshold',
    props: {
        data: { default: undefined },
        help: { type: Boolean, default: false },
        header: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const showHelp = ref(false);
        const has_heart_rate_coeffs = computed(() => {
            return props.data === undefined || props.data.heartrate_c0 === null || props.data.heartrate_c1 === null ? false : true;
        });
        const threshold_abs = computed(() => {
            return toFixedNumberStrWithFallback(props.data?.threshold_abs, 0);
        });
        const threshold_rel = computed(() => {
            return toFixedNumberStrWithFallback(props.data?.threshold_rel, 2);
        });
        const threshold_perc_vo2max = computed(() => {
            return toFixedNumberStrWithFallback(props.data?.threshold_perc_vo2max, 2);
        });
        const heartrate_threshold = computed(() => {
            return props.data === undefined || props.data.heartrate_c0 === null || props.data.heartrate_c1 === null
                ? '-'
                : props.data.heartrate_max === null
                    ? Math.round(props.data.heartrate_c0 * props.data.threshold_abs + props.data.heartrate_c1)
                    : Math.min(props.data.heartrate_max, Math.round(props.data.heartrate_c0 * props.data.threshold_abs + props.data.heartrate_c1));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.header)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(___)({ en: 'Anaerobic Threshold', de: 'Anaerobe Schwelle' })), 1 /* TEXT */),
                                (__props.help)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (showHelp.value = !showHelp.value)),
                                        type: "button",
                                        class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500",
                                        "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                                        title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                                    }, [
                                        _cache[0] || (_setBlockTracking(-1, true),
                                            (_cache[0] = _createVNode(SvgVue, {
                                                class: "w-4 h-4",
                                                icon: "lucide/circle-question-mark"
                                            })).cacheIndex = 0,
                                            _setBlockTracking(1),
                                            _cache[0])
                                    ], 8 /* PROPS */, _hoisted_5))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            (__props.help)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["collapsible", showHelp.value ? 'expanded' : ''])
                                }, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(___)({
                                        en: 'The anaerobic threshold is defined as the balance of lactate build-up and decomposition. Under these conditions, carbohydrates exclusively serve as the energy sources.',
                                        de: 'Die anaerobe Schwelle zeichnet sich durch ein Gleichgewicht aus Laktataufbau und -abbau aus. Unter diesen Bedingungen dienen ausschließlich Kohlenhydrate als Energiequellen.',
                                    })), 1 /* TEXT */)
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("ul", _hoisted_7, [
                        _createElementVNode("li", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(___)({
                                en: 'Absolute threshold power',
                                de: 'Absolute Schwellenleistung',
                            })), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(threshold_abs.value)
                                }, null, 8 /* PROPS */, _hoisted_11),
                                _cache[2] || (_cache[2] = _createTextVNode(" W", -1 /* CACHED */))
                            ])
                        ]),
                        _createElementVNode("li", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(___)({
                                en: 'Relative threshold power',
                                de: 'Relative Schwellenleistung',
                            })), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(threshold_rel.value)
                                }, null, 8 /* PROPS */, _hoisted_15),
                                _cache[3] || (_cache[3] = _createTextVNode(" W/kg", -1 /* CACHED */))
                            ])
                        ]),
                        _createElementVNode("li", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(___)({ en: 'Utilization of the ', de: 'Ausnutzung der ' })) + " VO2max ", 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(threshold_perc_vo2max.value)
                                }, null, 8 /* PROPS */, _hoisted_19),
                                _cache[4] || (_cache[4] = _createTextVNode(" %", -1 /* CACHED */))
                            ])
                        ]),
                        (has_heart_rate_coeffs.value)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(___)({ en: 'Heart rate at threshold power', de: 'Herzfrequenz bei Schwellenleistung' })), 1 /* TEXT */),
                                _createElementVNode("div", _hoisted_22, [
                                    _cache[5] || (_cache[5] = _createTextVNode("~", -1 /* CACHED */)),
                                    _createElementVNode("span", {
                                        textContent: _toDisplayString(heartrate_threshold.value)
                                    }, null, 8 /* PROPS */, _hoisted_23),
                                    _cache[6] || (_cache[6] = _createTextVNode(" /min", -1 /* CACHED */))
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
